import { apiFetch } from '../../systems/api-client';

export interface TextPlaceholderKey {
  key: string;
  label: string | null;
  description: string | null;
  created_at?: string;
}

export interface TextPlaceholderScenarioEntry extends TextPlaceholderKey {
  value: string | null;
}

export async function fetchTextPlaceholderKeys(
  query?: string
): Promise<TextPlaceholderKey[]> {
  const params = query ? `?q=${encodeURIComponent(query)}` : '';
  const response = await apiFetch(`/api/auth/admin/text-placeholders/keys${params}`);
  const data = await response.json();
  if (!response.ok) throw new Error(data.error || data.message || 'Failed to fetch placeholder keys');
  return data;
}

export async function createTextPlaceholderKey(
  payload: { key: string; label?: string; description?: string }
): Promise<TextPlaceholderKey> {
  const response = await apiFetch('/api/auth/admin/text-placeholders/keys', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data.error || data.message || 'Failed to create placeholder key');
  return data;
}

export async function fetchScenarioTextPlaceholders(
  scenarioId: string
): Promise<TextPlaceholderScenarioEntry[]> {
  const response = await apiFetch(`/api/auth/admin/text-placeholders/${encodeURIComponent(scenarioId)}`);
  const data = await response.json();
  if (!response.ok) throw new Error(data.error || data.message || 'Failed to fetch scenario placeholders');
  return data;
}

export async function upsertScenarioTextPlaceholderValue(
  scenarioId: string,
  key: string,
  value: string
): Promise<void> {
  const response = await apiFetch(
    `/api/auth/admin/text-placeholders/${encodeURIComponent(scenarioId)}/${encodeURIComponent(key)}`,
    {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ value }),
    }
  );
  const data = await response.json();
  if (!response.ok) throw new Error(data.error || data.message || 'Failed to update placeholder value');
}
